const setCode = code => {
    return {
        type: 'SET_CODE',
        code
    };
};

const setComponent = component => {
    return {
        type: 'SET_COMPONENT',
        component
    };
};

const setName = name => {
    return {
        type: 'SET_NAME',
        name
    };
};

const setRut = rut => {
    return {
        type: 'SET_RUT',
        rut
    };
};

const setToken = token => {
    return {
        type: 'SET_TOKEN',
        token
    };
};

const setExpiration = expiration => {
    return {
        type: 'SET_EXPIRATION',
        expiration
    }
};

const setExpirationSecondsToken = expirationSecondsToken => {
    return {
        type: 'SET_EXPIRATION_SECONDS_TOKEN',
        expirationSecondsToken
    }
};

const setStepInfo = stepInfo => {
    return {
        type: 'SET_STEP_INFO',
        stepInfo
    };
};

const setImage = image => {
    return {
        type: 'SET_IMAGE',
        image
    };
};

const setStepData = stepData => {
    return {
        type: 'SET_STEP_DATA',
        stepData
    }
};

const resetAllData = () => {
    return {
        type: 'RESET_ALL_DATA'
    }
};

const setLoader = loader => {
    return {
        type: 'SET_LOADER',
        loader
    }
};

const setShowError = showError => {
    return {
        type: 'SET_SHOW_ERROR',
        showError
    }
};

const setErrorType = errorType => {
    return {
        type: 'SET_ERROR_TYPE',
        errorType
    }
};

const setErrorMessage = errorMessage => {
    return {
        type: 'SET_ERROR_MESSAGE',
        errorMessage
    }
};

const setErrorData = errorData => {
    return {
        type: 'SET_ERROR_DATA',
        errorData
    }
};

const setIsSigned = isSigned => {
    return {
        type: 'SET_IS_SIGNED',
        isSigned
    }
};

const setWindowVisibility = windowVisibility => {
    return {
        type: 'SET_WINDOW_VISIBILITY',
        windowVisibility
    }
};

const setMultiple = multiple => {
    return {
        type: 'SET_MULTIPLE',
        multiple
    }
};

const setMessageModalVisibility = messageModalVisibility => {
    return {
        type: 'SET_MESSAGE_MODAL_VISIBILITY',
        messageModalVisibility
    }
};

const setPasswordType = passwordType => {
    return {
        type: 'SET_PASSWORD_TYPE',
        passwordType
    }
}

const setCompanyLogo = companyLogo => {
    return {
        type: 'SET_COMPANY_LOGO',
        companyLogo
    }
}

const setSource = source => {
    return {
        type: 'SET_SOURCE',
        source
    }
}

const setIdentityType = identityType => {
    return {
        type: 'SET_IDENTITY_TYPE',
        identityType
    };
};

const setDocuments = documents => {
    return {
        type: 'SET_DOCUMENTS',
        documents,
    }
}

const setData = data => {
    return {
        type: 'SET_DATA',
        data,
    }
}

const setModalButton = modalButton => {
    return {
        type: 'SET_MODAL_BUTTON',
        modalButton,
    }
}

const setPlate = plate => {
    return {
        type: 'SET_PLATE',
        plate,
    };
};

const setTab = tab => {
    return {
        type: 'SET_TAB',
        tab,
    };
};

export {
    setCode,
    setComponent,
    setName,
    setRut,
    setToken,
    setStepInfo,
    setImage,
    setStepData,
    resetAllData,
    setLoader,
    setShowError,
    setErrorType,
    setErrorMessage,
    setErrorData,
    setIsSigned,
    setExpiration,
    setExpirationSecondsToken,
    setWindowVisibility,
    setMultiple,
    setMessageModalVisibility,
    setPasswordType,
    setCompanyLogo,
    setSource,
    setIdentityType,
    setDocuments,
    setData,
    setModalButton,
    setPlate,
    setTab,
};


